import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=f637abda&scoped=true&"
import script from "./Dropzone.vue?vue&type=script&lang=ts&"
export * from "./Dropzone.vue?vue&type=script&lang=ts&"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=f637abda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f637abda",
  null
  
)

export default component.exports